import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Product } from '@inter-ikea-storageone/range';
import React from 'react';
import Body from 'ui/Typography/Body';
import Title from 'ui/Typography/Title';

interface ComplianceInformationProps {
  product: Product;
}

const ComplianceInformation: React.FC<ComplianceInformationProps> = ({ product }) => {
  const hasCountryOfOrigin =
    product &&
    product.complainceInformation &&
    product.complainceInformation.length &&
    product.complainceInformation.find(
      (info: { headingText: string }) => info.headingText === 'Country of Origin'
    );

  if (hasCountryOfOrigin) {
    const title = product.complainceInformation[0].headingText;
    const countries = product.complainceInformation[0].text
      .split(',')
      .map((t: string) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase())
      .join(', ');

    return (
      <>
        <Title mt="md" type={ThemeFontStyleTypeEnum.headingXSmall} color="grey.700">
          {title}
        </Title>
        <Body color="grey.500" type={ThemeFontStyleTypeEnum.bodySmall}>
          {countries}
        </Body>
      </>
    );
  }

  return null;
};

export default ComplianceInformation;
